import { render, staticRenderFns } from "./knowledgeSpaceDialog.vue?vue&type=template&id=32558929&scoped=true&"
import script from "./knowledgeSpaceDialog.vue?vue&type=script&lang=js&"
export * from "./knowledgeSpaceDialog.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeSpaceDialog.vue?vue&type=style&index=0&id=32558929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32558929",
  null
  
)

component.options.__file = "knowledgeSpaceDialog.vue"
export default component.exports